export default function StoreButton({ store, large = false }) {
  const isApple = store === 'apple';

  const badge = isApple
    ? '/assets/badge-appstore.svg'
    : '/assets/badge-googleplay.svg';

  const alt = isApple
    ? 'Download on the App Store'
    : 'Get it on Google Play';

  const link = isApple
    ? 'https://apps.apple.com/de/app/lexira-word-puzzle/id6766865962?l=en-GB'
    : 'https://play.google.com/store/apps/details?id=app.lexira.com';

  return (
    <a
      href={link}
      className={`btn-store-badge${large ? ' btn-store-badge--large' : ''}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={badge} alt={alt} />
    </a>
  );
}